// extracted by mini-css-extract-plugin
export var after = "style-module--after--3f02c";
export var after__block = "style-module--after__block--c4f34";
export var after__blockSec = "style-module--after__block--sec--4d95f";
export var after__btn = "style-module--after__btn--70c12";
export var after__img = "style-module--after__img--888e2";
export var after__infoBlock = "style-module--after__info-block--6bceb";
export var after__item = "style-module--after__item--5842a";
export var after__itemDescr = "style-module--after__item-descr--912f4";
export var after__title = "style-module--after__title--65b69";